.container {
  width: 100%;
  height: 8px;
  cursor: ns-resize;
}
